import React from "react";

const NotFound = () => (
  <div>
    <h2>Couldn't find anything here....</h2>
  </div>
);

export default NotFound;
